import type { PromoAction } from '@/types';

export const PROMO_OFFER_NAME_ATTRIBUTE = 'promoOfferName';
export const JOBS_STORAGE_KEY = 'promoJobs';
export const JOBS_UPDATED_EVENT = 'jobsStorageUpdated';

export enum PromoJobStatus {
    complete = '🎉 Complete',
    'complete-with-errors' = '❎ Complete With Errors',
    failed = '❌ Failed',
    pending = '⌛ Pending',
    processing = '🔄 In Progress',
}

export enum BulkPromoAction {
    generate = 'Code generation',
    export = 'Code export',
}

export enum PromoJobAction {
    add = 'Add',
    remove = 'Remove',
    // 'remove-all' = 'Remove All',
}

export const AVAILABLE_ACTIONS: PromoAction[] = [
    'add',
    'remove',
    // 'remove-all',
];

export const promoActionOptions = [
    {
        label: PromoJobAction.add,
        value: 'add' as PromoAction,
    },
    {
        label: PromoJobAction.remove,
        value: 'remove' as PromoAction,
    },
    // {
    //     label: PromoJobAction['remove-all'],
    //     value: 'remove-all' as PromoAction,
    // },
];
